import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getShopItemsStreamId } from '../../../../../streams/shop';
import { ShopItemType } from '../../../../../../types/shop';
import { ModuleType } from '../../../../../../types/modules';
import { AppState } from '../../../../../../types/store';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';
import { getModuleDataByModuleType } from '../../../../../selectors/modules';
import { openCommissionEditModal } from '@wix/da-shared-react/pkg/redux/commissions/actionCreators';
import { Props } from './CommissionSlider';

type StateProps = Pick<
  Props,
  | 'streamId'
  | 'isOpenForCommissions'
  | 'commissions'
  | 'total'
  | 'isOwner'
  | 'username'
  | 'isPaywalUpdates'
>;
type DispatchProps = Pick<Props, 'openCommissionEditModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const streamId = getShopItemsStreamId(ShopItemType.COMMISSIONS);
  const { isOpenForCommissions } = getModuleDataByModuleType(
    state,
    ModuleType.COMMISSIONS
  );

  return {
    streamId,
    isOpenForCommissions,
    commissions: getDeviationsByIds(
      state,
      streamSelectors.getItems(state, streamId)
    ),
    total: streamSelectors.getTotal(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
    username: getProfileOwnerUser(state).username,
    isPaywalUpdates: flagEnabled(state, 'paywall_updates'),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  openCommissionEditModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
